/**
 * Транспорт домена заказов.
 *
 * Гость читает СВОИ заказы общим маршрутом: /guest/orders не существует, и
 * право анонимной сессии на scope=own подтверждено контуром 28.08.
 * brandId приезжает из useGuestPoint — единственного его источника (Ф4б).
 */

import { api, useInvalidate } from "@/core/api-client";

export function useOrderQuery(orderId: string | null, brandId: string | null) {
  return api.useQuery(
    "get",
    "/orders/{id}",
    { params: { path: { id: orderId ?? "" }, query: { brandId: brandId ?? "" } } },
    { enabled: Boolean(orderId && brandId) }
  );
}

/**
 * Последний черновик точки — восстановление незаконченной корзины.
 *
 * Сортировка NUMBER_DESC, а не по времени создания: createdTime среди
 * стратегий сортировки сервера нет, а номер сквозной внутри бренда и растёт
 * монотонно.
 */
export function useLastDraftOrder(
  brandId: string | null,
  pointId: string | null
) {
  return api.useQuery(
    "get",
    "/orders",
    {
      params: {
        query: {
          brandId: brandId ?? "",
          scope: "own",
          isDraft: true,
          pointIds: pointId ?? "",
          sort: "NUMBER_DESC",
          limit: 1,
        },
      },
    },
    { enabled: Boolean(brandId && pointId) }
  );
}

export function useOrderCreate() {
  const invalidate = useInvalidate();
  return api.useMutation("post", "/orders", {
    onSuccess: () => invalidate(["/orders"]),
  });
}

export function useOrderUpdate() {
  const invalidate = useInvalidate();
  return api.useMutation("patch", "/orders/{id}", {
    onSuccess: () => invalidate(["/orders", "/orders/{id}"]),
  });
}
